module.exports = __webpack_public_path__ + "media/images/lb/338-bc3727429ef93e07c34811ca470ab2be.svg";